import { SortDirection } from '../../../../../../enums/sortDirection'
import { BillsTableSortCriterion } from '../../../../elements/BillsTable'
import { BillsSortProperty } from '../../../../query-api'
import { UseFetchBillsProps } from '../hooks/useFetchBills'

const tableSortKeyToApiSortKeyMap: Record<BillsTableSortCriterion['key'], BillsSortProperty> = {
  receiptDate: BillsSortProperty.EntryDate,
  dueDate: BillsSortProperty.DueDate,
}

export const transformBillsTableSortToBillsApiSort = (
  tableSortCriteria: BillsTableSortCriterion | null,
): UseFetchBillsProps['sorting'] => {
  if (!tableSortCriteria) {
    return
  }

  const direction = tableSortCriteria.direction === 'ascending' ? SortDirection.Asc : SortDirection.Desc
  const apiSortKey = tableSortKeyToApiSortKeyMap[tableSortCriteria.key]

  // Run-time safety check to prevent sorting with unsupported keys.
  if (!apiSortKey) {
    return
  }

  return {
    key: apiSortKey,
    direction,
  }
}
